import React from 'react';
import { useTranslation } from 'react-i18next';

function Badge({ state }) {
  const color =
    state === 'operational' ? 'bg-emerald-100 text-emerald-800 border-emerald-200' :
    state === 'degraded'    ? 'bg-amber-100 text-amber-800 border-amber-200' :
    'bg-rose-100 text-rose-800 border-rose-200';
  return (
    <span className={`inline-flex items-center rounded px-2 py-0.5 text-xs border ${color}`}>
      {state}
    </span>
  );
}

export default function Status() {
  const { t } = useTranslation();
  const UPDATED = new Date().toISOString().slice(0, 10);

  // Manually adjust these when needed (or wire to your health endpoints)
  const services = [
    { key: 'api',       label: t('status.services.api'),       state: 'operational', note: t('status.notes.ok') },
    { key: 'database',  label: t('status.services.database'),  state: 'operational', note: t('status.notes.ok') },
    { key: 'storage',   label: t('status.services.storage'),   state: 'operational', note: t('status.notes.ok') },
    { key: 'email',     label: t('status.services.email'),     state: 'operational', note: t('status.notes.ok') },
  ];

  return (
    <div className="max-w-4xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('status.title')}</h1>
      <p className="text-sm text-gray-500 mb-6">{t('status.updated', { date: UPDATED })}</p>

      <p className="mb-6">{t('status.intro')}</p>

      <div className="grid gap-3">
        {services.map(s => (
          <div key={s.key} className="flex items-center justify-between border rounded px-3 py-2">
            <div className="font-medium">{s.label}</div>
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600">{s.note}</span>
              <Badge state={s.state} />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 text-sm text-gray-700">
        {t('status.incidentsBlurb')}{' '}
        <a className="text-blue-700 underline" href="mailto:info@vbwebb.se">info@vbwebb.se</a>.
      </div>
    </div>
  );
}
